import React, { useEffect, useRef, useState } from 'react';
import './PopupModal.css';
import { Link } from 'react-router-dom';
// import popupImage from '../assets/ai2.jpg'; // 🔁 Replace with your actual image

const PopupModal = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState('');
  const modalRef = useRef(null);

  // Check if popup should show (once per day)
  useEffect(() => {
    const lastShownDate = localStorage.getItem('popupLastShown');
    const today = new Date().toDateString();

    if (!lastShownDate || lastShownDate !== today) {
      const timer = setTimeout(() => {
        setShow(true);
        localStorage.setItem('popupLastShown', today);
      }, 2500); // Show after 2.5s

      return () => clearTimeout(timer);
    }
  }, []);

  // Hide popup on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter Email:', email);
    setShow(false);
    // 📤 Add your email submission logic here
  };

  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-modal" ref={modalRef}>
        <button className="close-btn" onClick={() => setShow(false)}>×</button>
        
        <div className="popup-content">
        
          <div className="popup-text">
            <h2>🚀 Let's Build Something Incredible</h2>
            <p>Subscribe to our newsletter or get a free consultation on your next big idea.</p>
            <form onSubmit={handleSubmit} className="popup-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">Subscribe</button>
            </form>
            <Link to="/contact-us" className="cta-button" style={{ textDecoration: 'none' }}>
              Get a Free Quote →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;